(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-back-side-engraving"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ss-back-side-engraving')) {
  customElements.define('ss-back-side-engraving', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.input = this.querySelector('.ss-back-side-engraving__input');
      this.consent = this.querySelector('[data-ss-engraving-consent]');
      this.confirmed = this.querySelector('[data-ss-engraving-confirmed]');
      this.productProperty = this.querySelector('[data-ss-engraving-product-property]');
      this.fields = this.querySelector('[data-ss-engraving-fields]');
      this.counter = this.querySelector('[data-back-side-count]');
      this.error = this.querySelector('[data-engraving-error]');
      this.abort = new AbortController();
      this.showErrors = false;
      const options = { signal:this.abort.signal };
      if (this.consent && window.SoulyshineEngraving) this.consent.disabled = false;
      const update = (validate = false) => {
        if (validate) this.showErrors = true;
        if (this.consent) {
          const selected = this.consent.checked && !this.consent.disabled;
          this.fields.hidden = !selected;
          this.consent.setAttribute('aria-expanded', String(selected));
          this.input.disabled = !selected;
          this.input.required = selected;
          this.confirmed.disabled = !selected;
          this.productProperty.disabled = !selected;
          if (!selected) this.input.value = '';
          this.confirmed.value = selected ? window.SoulyshineEngraving.confirmed : '';
        }
        const count = this.input.value.length;
        const maximum = Number(this.input.dataset.maxCharacters) || 0;
        const message = !this.input.disabled && maximum > 0 && count > maximum
          ? `Please enter no more than ${maximum} characters.`
          : this.input.required && !this.input.value.trim()
            ? 'Please enter your back-side text, or uncheck the engraving option.' : '';
        this.counter.textContent = count;
        this.input.setCustomValidity(message);
        const visibleError = message && (this.showErrors || count > 0);
        this.input.setAttribute('aria-invalid', visibleError ? 'true' : 'false');
        this.error.textContent = visibleError ? message : '';
        this.error.hidden = !visibleError;
      };
      this.input.addEventListener('input', () => update(), options);
      this.consent?.addEventListener('change', () => {
        this.showErrors = false;
        update();
        if (this.consent.checked) this.input.focus();
      }, options);
      update();
      const validate = event => {
        update(true);
        if (!this.input.checkValidity()) {
          event.preventDefault(); event.stopImmediatePropagation();
          this.input.reportValidity(); this.input.focus();
        }
      };
      document.addEventListener('submit', event => {
        if (event.target === this.input.form) validate(event);
      }, { ...options, capture:true });
      document.addEventListener('click', event => {
        const target = event.target.closest?.('#customily-cart-btn, .main-product-atc, button[name="add"], [data-skip-cart="true"]');
        if (!target) return;
        const section = this.closest('[id^="MainProduct-"]');
        if (target.form !== this.input.form && !(section?.contains(target)) && !target.closest('sticky-atc')) return;
        validate(event);
      }, { ...options, capture:true });
      document.addEventListener('formdata', event => {
        if (event.target !== this.input.form) return;
        update();
        const propertyName = this.input.name;
        const propertyLabel = propertyName.slice('properties['.length, -1);
        const itemKeys = [...event.formData.keys()].filter(key => /^items\[\d+\]\[properties\]\[/.test(key) && key.endsWith(`[properties][${propertyLabel}]`));
        const keys = itemKeys.length ? itemKeys : [propertyName];
        if (itemKeys.length) event.formData.delete(propertyName);
        for (const key of keys) {
          if (!this.input.disabled && this.input.value.trim()) event.formData.set(key, this.input.value);
          else event.formData.delete(key);
          if (this.consent) {
            const prefix = key.slice(0, key.lastIndexOf('['));
            if (this.consent.checked && !this.consent.disabled) {
              event.formData.set(prefix + '[_ss_back_engraving_product]', this.dataset.ssEngravingProduct);
              event.formData.set(prefix + '[Back-side engraving fee]', this.confirmed.value);
            } else {
              event.formData.delete(prefix + '[_ss_back_engraving_product]');
              event.formData.delete(prefix + '[Back-side engraving fee]');
              event.formData.delete(prefix + '[_ss_back_engraving_group]');
            }
          }
        }
        if (this.consent && window.SoulyshineEngraving) {
          try { window.SoulyshineEngraving.prepareFormData(event.formData); } catch (_) {}
        }
      }, { ...options, capture:true });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-engraving-text"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ss-engraving-text')) {
  customElements.define('ss-engraving-text', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.counter = this.querySelector('[data-engraving-count]');
      this.abort = new AbortController();
      const options = { signal:this.abort.signal };
      const update = () => {
        this.counter.textContent = this.input.value.length;
        this.input.setCustomValidity(this.input.required && !this.input.value.trim() ? 'Please enter your engraving text.' : '');
      };
      this.input.addEventListener('input', update, options);
      update();
      // The theme's AJAX form disables native validation. Validate this field
      // before its submit handler, including submits from the sticky button.
      document.addEventListener('submit', event => {
        if (event.target !== this.input.form) return;
        update();
        if (!this.input.checkValidity()) {
          event.preventDefault(); event.stopImmediatePropagation();
          this.input.reportValidity(); this.input.focus();
        }
      }, { ...options, capture:true });
      // Keep one public line-item property in native and AJAX FormData.
      document.addEventListener('formdata', event => {
        if (event.target !== this.input.form) return;
        if (this.input.value.trim()) event.formData.set('properties[Engraving Text]', this.input.value);
        else event.formData.delete('properties[Engraving Text]');
      }, { ...options, capture:true });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
